import { useDashboard } from '@/hooks/useDashboard';
import { useDashboardStore } from '@/stores/dashboardStore';
import { activeFilterCount } from '@/utils/formatters';
import KPICards from '@/components/KPICards';
import ChartCard from '@/components/charts/ChartCard';

export default function Overview() {
  const { tabData, loading, error, currentTab } = useDashboard();
  const filters = useDashboardStore((s) => s.filters);
  const data = tabData[currentTab];
  const hasActiveFilters = activeFilterCount(filters) > 0;

  if (loading) return <div className="loading">加载中...</div>;
  if (error) return <div className="error">加载失败：{error}</div>;
  if (!data) return <div className="empty">暂无数据</div>;

  const chartKeys = Object.keys(data.charts || {});

  return (
    <div className="container">
      {hasActiveFilters && (
        <div className="filter-scope-hint">
          当前已启用明细筛选，但综合驾驶舱的 KPI/图表为全国口径快照，不受筛选影响；切换至各明细页签后，下方表格会自动按筛选条件过滤。
        </div>
      )}
      <KPICards kpi={data.kpi} />

      {chartKeys.length > 0 && (
        <div className="section">
          <div className="section-title">趋势 / 结构 / 排名</div>
          <div className="chart-row">
            {chartKeys.map((key) => {
              const chart = data.charts![key];
              const isFull = key === 'customer_trend' || key === 'coverage' || key === 'quality' || key === 'rank';
              return <ChartCard key={key} chartKey={key} chart={chart} fullWidth={isFull} />;
            })}
          </div>
        </div>
      )}
    </div>
  );
}
